import React from 'react'
import { checkTextTranslation, checkTranslation } from '../../utils/useful'
import FormViewer from '../FormViewer'
import Collapsible from 'react-collapsible'

class GenerateCodeInput extends React.Component {
    state = {
        headers: [
            { col: '10', key: 'name', type: 'TextInput', information: { label: '{{lang}}کد', disabled: true, required: true }, showMain: true, inExport: true },
        ],
        headers2: [
            { col: '6', type: 'SelectInput', key: 'type', information: { label: '{{lang}}نوع کد', type: 'local', items: [{ value: 'auto', title: 'Auto Fill' }, { value: 'manual', title: 'manual' }], isSearchable: true, placeholder: '{{lang}}نوع کد', required: true }, showMain: true },
            {
                key: 'autoType',
                type: 'SelectInput',
                information: {
                    label: '{{lang}}نوع کد اتوماتیک',
                    // updateAfterSelect: true,
                    // isSearchable: false,
                    type: 'local',
                    items: [{ value: 'auto', title: 'Auto Fill' }, { value: 'manual', title: 'manual' }],
                    isSearchable: false,
                    placeholder: '{{lang}}نوع کد اتوماتیک را انتخاب کنید',
                    required: false
                },
                dependencies: [{
                    refKey: 'type',
                    targetKey: 'SelectInput',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'and',
                            conditions: {
                                1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'auto' } }
                            }
                        },
                    },
                    show: true,
                    init: true,
                    changeValue: {
                        targetKey: "latitude",
                        value: null,
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.hasLocation' }, operator: { value: '==' }, target: { value: false } }
                                }
                            },
                        },
                    } //refKey
                    // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                }],
                showMain: false

            },
            {
                key: 'challenges',
                type: 'SlidesChallengeInput',
                information: {
                    label: '{{lang}}Slides',
                    updateAfterSelect: true,
                    isSearchable: false,
                    fields: { title: 'name', value: '_id' },
                    type: 'api',
                    isSearchable: false,
                    placeholder: '{{lang}}slides',
                    required: false
                },
                dependencies: [{
                    refKey: 'type',
                    targetKey: 'challenges',
                    conditions: {
                        root: {
                            id: 'root',
                            action: 'and',
                            conditions: {
                                1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'chalange' } }
                            }
                        },
                    },
                    show: true,
                    init: true,
                    changeValue: {
                        targetKey: "latitude",
                        value: null,
                        conditions: {
                            root: {
                                id: 'root',
                                action: 'and',
                                conditions: {
                                    1: { id: 1, source: { value: '@data.hasLocation' }, operator: { value: '==' }, target: { value: false } }
                                }
                            },
                        },
                    } //refKey
                    // changeHeader: { key: 'information.filter.id', value: '@data.thing' },

                }],
                showMain: false

            },
        ],
        code: [
            { code: '' },
        ],
        collapse: {}
    }

    toggleOpen = (key) => {
        let collapse = this.state.collapse
        collapse[key] = collapse[key] == null ? true : !collapse[key]
        this.setState({ collapse })
    }
    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value, this.props.extra)
        }
    }
    addCode() {
        let code = this.state.code
        code.push({ code: '' })
        this.setState({ code })
    }
    removeCode(index) {
        let code = this.state.code
        code.splice(index, 1)
        this.setState({ code })
    }
    render() {
        return (
            <div className="w-100 h-100">
                <img className='cursor-pointer' onClick={() => this.addCode()} width={25} src="/images/icons/add.png" alt="add" />
                {this.state.code.map((prop, index) => {
                    return (
                        <>
                            <div className='flexcc'>
                                <FormViewer ref={el => this.form = el} headers={this.state.headers} initData={this.state.data ?? this?.props?.user?.info} errors={this.state.errors} inputClass={'modern-input'} />
                                <p onClick={() => this.toggleOpen(index)} style={{ border: '1px solid rgba(0,0,0,0.1)', borderRadius: '5px' }} className='mt-2 px-2 py-2 cursor-pointer'>edit</p>
                                <p onClick={() => this.removeCode(index)} style={{ border: '1px solid rgba(0,0,0,0.1)', borderRadius: '5px' }} className='mt-2 px-2 py-2 text-danger cursor-pointer' >remove</p>
                            </div>
                            <Collapsible open={this.state.collapse[index]} transitionTime={100}>
                                <FormViewer ref={el => this.form = el} headers={this.state.headers2} initData={this.state.data ?? this?.props?.user?.info} errors={this.state.errors} inputClass={'modern-input'} />
                            </Collapsible>
                        </>
                    )
                })}
            </div>
        )
    }
}

export default GenerateCodeInput;